<style scoped>

</style>

<template>
  <div id="container">
    <router-view></router-view>
    <back-top v-show="false"></back-top>
  </div>
</template>

<script>
  import backTop from '@/components/back-top'
  import { mapMutations, mapActions, mapGetters } from 'vuex'
  export default {
    name: "App",
    components: {
      backTop
    },
    created: function() {
      // 获取系统配置
      // this.getSysConfig({})
    },
    methods: {
      ...mapActions({
        // getSysConfig: 'app/getSysConfig'
      }),
    },
    mounted() {

    },
  }
</script>
